// Helper function to get environment variables from runtime or build-time config
export const getEnvVar = (runtimeKey: string, buildTimeKey: string, defaultValue: string = ''): string => {
    // Check runtime config first (production)
    if (typeof window !== 'undefined' && (window as any)._env_ && (window as any)._env_[runtimeKey]) {
        return (window as any)._env_[runtimeKey];
    }
    // Fall back to build-time config (development)
    return process.env[buildTimeKey] || defaultValue;
};

// Get API URL from runtime or build-time config
export const getApiUrl = (): string => {
    return getEnvVar('API_URL', 'REACT_APP_API_URL', '');
};
